import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCreateLocationSetCacheKeys: AllRouteEndpoints[] = ["/engagement/location_set_data"];
